import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { DataTableColumnHeader } from "@/components/shared/data-table/data-table-column-header";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

interface TagProfile {
  id: string;
  name: string;
  language: string;
}

interface Tag {
  id: string;
  tag_profiles: TagProfile[];
  product_containers: { id: string }[];
  created_at: string;
  updated_at: string;
}

export const columns: ColumnDef<Tag>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => (
      <div className="text-xs text-muted-foreground">{row.getValue("id")}</div>
    ),
    meta: { width: "50px" },
  },
  {
    accessorFn: (row) => row.tag_profiles[0]?.name,
    id: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">
            {row.getValue("name")}
          </span>
        </div>
      );
    },
  },
  {
    accessorFn: (row) => row.product_containers.length,
    id: "products_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Products" />
    ),
    cell: ({ row }) => {
      const count = row.getValue("products_count") as number;
      const navigate = useNavigate();

      const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent row click event from firing
        const tagId = row.original.id;
        navigate(`/products?tags=${tagId}`);
      };

      return (
        <div className="flex items-center">
          <Badge
            variant="secondary"
            className="rounded-sm cursor-pointer hover:underline"
            onClick={handleClick}
          >
            {count} product{count !== 1 ? "s" : ""}
          </Badge>
        </div>
      );
    },
    meta: { width: "100px" },
  },
  // {
  //   accessorKey: "created_at",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Created" />
  //   ),
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex w-[150px] items-center">
  //         {format(new Date(row.getValue("createdAt")), "MMM d, yyyy")}
  //       </div>
  //     );
  //   },
  // },
  // {
  //   accessorKey: "updated_at",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Updated" />
  //   ),
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex w-[150px] items-center">
  //         {format(new Date(row.getValue("updatedAt")), "MMM d, yyyy")}
  //       </div>
  //     );
  //   },
  // },
];
